import { Box, Container } from '@chakra-ui/react';
import { useLocation, useParams } from 'react-router-dom';
import EmptyAlert from '../../emptyAlert/EmptyAlert';
import findRoute from '../../../utils/findRoute';
import { useLazyGetProductsQuery } from '../../../redux/platimarket/platimarket.api';
import Loader from '../../loader/Loader';
import { useAppSelector } from '../../../hooks/redux';
import { useDebounce } from '../../../hooks/useDebounce';
import { useEffect } from 'react';
import ProductList from '../../productList/ProductList';
import SupportAlert from '../../supportAlert/SupportAlert';
import { useTranslation } from 'react-i18next';
import { LOCALES } from '../../../config/locales/locales';
import { useLocaleType } from '../../../hooks/useLocaleType';

export default function ProductsCategory() {
    const { t, i18n } = useTranslation();

    const params = useParams();
    const categoryId = Number(params.categoryId);
    const { localeType } = useLocaleType(i18n);

    const location = useLocation();
    const pathName = location.pathname;

    const findedRoute = findRoute(pathName);
    const emptyMessage = findedRoute?.emptyMessage;

    const searchValue = useAppSelector((state) => state.search.name);
    const debouncedSearchValue = useDebounce(searchValue);

    const [fetchSearchProducts, { isFetching: isLoadingProducts, data: productsData }] =
        useLazyGetProductsQuery();

    const products = productsData?.results;
    const isProducts = !!products?.length;

    const isDebouncedSearchValue = !!debouncedSearchValue.length;

    useEffect(() => {
        if (isDebouncedSearchValue) {
            fetchSearchProducts({
                orderBy: 'position',
                sortBy: 'ASC',
                name: debouncedSearchValue,
                categoryId,
                localeTypeName: localeType?.name,
            });
        } else {
            fetchSearchProducts({
                orderBy: 'position',
                sortBy: 'ASC',
                categoryId,
                localeTypeName: localeType?.name,
            });
        }
    }, [debouncedSearchValue]);

    return (
        <Container height="calc(100vh + 200px)">
            {isLoadingProducts && (
                <Box display="flex" justifyContent="center" mt="30px">
                    <Loader />
                </Box>
            )}

            {!isLoadingProducts && isDebouncedSearchValue && !isProducts && (
                <SupportAlert
                    message={`${t('on-request')} «${debouncedSearchValue}» ${t('nothing-found')}`}
                />
            )}
            {isProducts && !isLoadingProducts && <ProductList products={products} />}

            {!isProducts && !isDebouncedSearchValue && !isLoadingProducts && (
                <EmptyAlert localeMessage={emptyMessage} />
            )}
        </Container>
    );
}
